export default "__VITE_ASSET__5ae86b38__"